import React, {useContext, useEffect, useRef, useState} from 'react';
import {Util} from "../util/Util";
import {get} from "../services/ApiService";
import {useFormContext} from "react-hook-form";
import AuthContext, {AuthProvider} from "../services/AuthProvider";
import ReactSlider from 'react-slider'
import { Chart as ChartJS, CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from 'chart.js'
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend)

export function useCustoDetalhado(props: any){
    const [ returnPayload, setReturnPayload ] = useState<any>();
    const { precoVenda, descontoVendedor, data, faturarPelaArgon } = props;
    useEffect(() => {
        get(`/?route=orcamento/form&action=custoDetalhado&kit_id=${data.kit.id}&preco_venda=${precoVenda}&desconto_vendedor=${descontoVendedor}&faturar_pela_argon=${faturarPelaArgon}`)
            .then((response: any) => {
                if(response.status == 200) {
                    setReturnPayload(response.data.payload);
                }
            })
            .catch((err) => {
            })
    }, [ props.precoVenda, props.data.kit.id, descontoVendedor, faturarPelaArgon ]);

    return returnPayload;
}


export function useMediaPrecos(kitId: any){
    const [ returnPayload, setReturnPayload ] = useState<any>();
    useEffect(() => {
        get(`/?route=orcamento/form&action=mediaPrecos&kit_id=${kitId}`) // &payload=${JSON.stringify(props)}
            .then((response: any) => {
                //setLoading(false);
                if(response.status == 200) {
                    console.log(response.data.payload);
                    setReturnPayload(response.data.payload);
                }
            })
            .catch((err) => {
                //setLoading(false);
            })
    }, [ kitId ]);

    return returnPayload;
}


export function MediaPrecos({ kit, precoVenda, descontoVendedor, consumoMedio, data, faturarPelaArgon }: any){
    const mediaPrecos = useMediaPrecos(kit.id);
    const formContext = useFormContext();
    const { user } = useContext<any>(AuthContext);

    const custoDetalhado = useCustoDetalhado({
        precoVenda,
        descontoVendedor,
        precoCusto: kit.preco,
        numeroPlacas: kit.numeroPlacas,
        potenciaPlacas: kit.potenciaPlacas,
        inversor: kit.inversor,
        data,
        acesso: user.acesso,
        faturarPelaArgon
    });

    function getCellStyle(item: any) {
        let payload: any = {
            textAlign: 'center'
        };

        if(item.percent >= 50){
            payload['fontWeight'] = 'bold';
        }

        if(custoDetalhado && item.preco < custoDetalhado.precoVendaMinimo){
            payload['backgroundColor'] = '#f8d7da';
            payload['opacity'] = 0.5;
        }else{
            payload['cursor'] = 'pointer';
            payload['backgroundColor'] = '#d4edda';
        }

        if(item.percent < 10){
            payload['opacity'] = 0.5;
            payload['color'] = '#CCC';
        }

        return payload;
    }

    if(!mediaPrecos){
        return <>Carregando...</>;
    }

    return <>
        <table style={{marginBottom: 10}}>
            <thead>
                <tr>
                    <th style={{textAlign: 'center'}} colSpan={(mediaPrecos?.semanasList?.length + 1) ?? 1}>Histórico de Preços</th>
                </tr>
                <tr>
                    <th style={{minWidth: '100px'}}>Preços / Semanas</th>
                    {
                        mediaPrecos && mediaPrecos.semanasList && mediaPrecos.semanasList.map((semanaItem: any, idx: number) => {
                            return  <th key={idx}>{ semanaItem }</th>
                        })
                    }
                </tr>
            </thead>
            <tbody>
            {
                mediaPrecos && mediaPrecos.precosList && mediaPrecos.precosList.map((precoItem: any, idx: number) => {
                    return <tr key={idx}>
                        <td style={{textAlign: 'right'}}>{ Util.moeda(precoItem) }</td>
                        {
                            mediaPrecos.semanasList && mediaPrecos.semanasList.map((semanaItem: any, idx2: number) => {
                                const subItem = mediaPrecos.table[precoItem][semanaItem];
                                return <td key={idx2} onClick={() => formContext.setValue('precoVendaBase', precoItem)}
                                           style={getCellStyle(subItem)}>
                                    { subItem.total } - { subItem.percent.toFixed(2) }%
                                </td>;
                            })
                        }
                    </tr>
                })
            }
            </tbody>
        </table>
    </>;
}

export function CostDetail(props: any){

    const { kit, precoVenda, descontoVendedor, consumoMedio, data, faturarPelaArgon, setFaturarPelaArgon } = props;
    const { user } = useContext<any>(AuthContext);

    const { setValue } = useFormContext();

    const custoDetalhado = useCustoDetalhado({
        precoVenda,
        descontoVendedor,
        precoCusto: kit.preco,
        numeroPlacas: kit.numeroPlacas,
        potenciaPlacas: kit.potenciaPlacas,
        inversor: kit.inversor,
        data,
        acesso: user.acesso,
        faturarPelaArgon
    });

    if(!custoDetalhado){
        return <>Carregando</>;
    }

    const setMinimalValue = () => {
        setValue('precoVendaBase', custoDetalhado.precoVendaMinimo);
    }

    const custoColor = (custoDetalhado.lucroLiquido < 8)?(custoDetalhado.lucroLiquido<5)?'#C00':'#009':'#090'

    return <>
        <table>
            <thead>
                <tr>
                    <th colSpan={3} style={{textAlign: 'center', padding: '10px'}}>
                        <label className="simple-checkbox" style={{justifyContent: 'center', margin: 0}}>
                            <input
                                type="checkbox"
                                checked={faturarPelaArgon}
                                onChange={(e) => setFaturarPelaArgon(e.target.checked)}
                            />
                            <span>Faturar pela Argon</span>
                        </label>
                    </th>
                </tr>
            </thead>
            <tbody>
            { user.acesso == 1 && custoDetalhado.custos.map((item: any, index: number) => {
                return item.show == true && <tr key={index}>
                    <th>{item.title}:</th>
                    <td style={{textAlign: 'right'}}>{Util.moeda(item.value)}</td>
                    <td style={{textAlign: 'center'}}>
                        {(item.percent).toFixed(2)}%
                    </td>
                </tr>
            }) }
            <tr>
                <th>Custo total:</th>
                <td style={{textAlign: 'right'}}>{Util.moeda(custoDetalhado.custoTotal)}</td>
                <td style={{textAlign: 'center'}}>{((custoDetalhado.custoTotal / precoVenda)*100).toFixed(2)}%</td>
            </tr>
            <tr>
                <th>Preço de Venda:</th>
                <td style={{textAlign: 'right'}}>{Util.moeda(precoVenda)}</td>
                <td style={{textAlign: 'center'}}>{((1 - (custoDetalhado.custoTotal / precoVenda))  * 100).toFixed(2)}%</td>
            </tr>

            { user.acesso == 1 && <tr>
                <th>Margem:</th>
                <td style={{textAlign: 'right'}}>{Util.moeda(precoVenda - custoDetalhado.custoTotal)}</td>
                <td colSpan={2} style={{textAlign: 'center', color: custoColor, fontSize: 14}} title={Util.moeda(precoVenda - custoDetalhado.custoTotal)}>{custoDetalhado.lucroLiquido.toFixed(2)}%</td>
            </tr> }
            <tr>
                <th style={{minWidth: '100px'}}>Venda mínimo:</th>
                <td style={{textAlign: 'center'}} colSpan={2} onClick={setMinimalValue}>{Util.moeda(custoDetalhado.precoVendaMinimo)}</td>
            </tr>
            </tbody>
        </table>
    </>

}

function OverloadBar({ kwp, inversor, overloadFator }: { kwp: number, inversor: number, overloadFator: number }) {
    const overloadMax = inversor * overloadFator;
    const overloadPct = Math.round((overloadFator - 1) * 100); // e.g., 70
    const dcRatio = kwp / inversor; // relative to nominal, e.g., 1.35
    const dcRatioDisplay = Math.round(dcRatio * 100); // e.g., 135

    // Limites fixos: verde ≤100%, amarelo ≤150%, vermelho >150%
    const yellowEnd = Math.min(1.5, overloadFator); // cap no overloadMax se < 1.5

    // Bar zone widths como % do total (0 → overloadMax)
    const nominalWidth = (1 / overloadFator) * 100;
    const yellowWidth = ((yellowEnd - 1) / overloadFator) * 100;
    // red zone fills the rest (só existe se overloadFator > 1.5)

    // Indicator position (capped at 100% of bar width)
    const indicatorPct = Math.min((kwp / overloadMax) * 100, 100);

    const color = dcRatio <= 1 ? '#28a745' : dcRatio <= 1.5 ? '#e6a817' : '#dc3545';

    return (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 2, minWidth: 220 }}>
            {/* Current position label above bar */}
            <div style={{ position: 'relative', height: 18, fontSize: 11 }}>
                <span style={{
                    position: 'absolute',
                    left: `${indicatorPct}%`,
                    transform: 'translateX(-50%)',
                    color,
                    fontWeight: 'bold',
                    whiteSpace: 'nowrap',
                }}>{dcRatioDisplay}% · {kwp} kWp</span>
            </div>
            {/* Bar */}
            <div style={{ position: 'relative', height: 10, display: 'flex', borderRadius: 4, overflow: 'hidden' }}>
                <div style={{ width: `${nominalWidth}%`, backgroundColor: '#28a745' }} />
                <div style={{ width: `${yellowWidth}%`, backgroundColor: '#e6a817' }} />
                <div style={{ flex: 1, backgroundColor: '#dc3545' }} />
                <div style={{
                    position: 'absolute',
                    left: `${indicatorPct}%`,
                    top: 0,
                    bottom: 0,
                    width: 2,
                    backgroundColor: '#000',
                    transform: 'translateX(-50%)',
                    opacity: 0.6,
                }} />
            </div>
            {/* Bottom labels */}
            <div style={{ position: 'relative', height: 14, fontSize: 10, color: '#666' }}>
                <span style={{ position: 'absolute', left: 0 }}>0%</span>
                <span style={{ position: 'absolute', left: `${nominalWidth}%`, transform: 'translateX(-50%)', whiteSpace: 'nowrap' }}>100% · {inversor} kW</span>
                <span style={{ position: 'absolute', right: 0, whiteSpace: 'nowrap' }}>Overload máximo: {overloadPct}% · {overloadMax.toFixed(1)} kW</span>
            </div>
        </div>
    );
}

function GeracaoChart({ kwp, inversor, overloadFator }: { kwp: number, inversor: number, overloadFator: number }) {
    const canvasRef = useRef<HTMLCanvasElement>(null);
    const chartRef = useRef<ChartJS | null>(null);
    const overloadMax = inversor * overloadFator;

    useEffect(() => {
        if (!canvasRef.current) return;

        const sigma = 2.2;
        const peakHour = 12;
        const step = 0.25;
        const labels: string[] = [];
        const delivered: number[] = [];   // min(p, inversor) — fill azul 0→nominal
        const theoretical: number[] = []; // curva completa — fill vermelho nominal→curva
        let totalEnergy = 0;
        let totalClipped = 0;

        for (let t = 0; t <= 24; t = parseFloat((t + step).toFixed(2))) {
            const p = kwp * Math.exp(-Math.pow(t - peakHour, 2) / (2 * sigma * sigma));
            labels.push(Number.isInteger(t) ? `${t}h` : '');
            delivered.push(parseFloat(Math.min(p, inversor).toFixed(3)));
            theoretical.push(parseFloat(p.toFixed(3)));
            totalEnergy += p * step;
            totalClipped += Math.max(0, p - inversor) * step;
        }

        const clippingPct = totalEnergy > 0
            ? (totalClipped / totalEnergy * 100).toFixed(1)
            : '0';

        const nominalLine = labels.map(() => inversor);
        const overloadLine = overloadMax > inversor ? labels.map(() => overloadMax) : null;

        if (chartRef.current) chartRef.current.destroy();

        const patternCanvas = document.createElement('canvas');
        patternCanvas.width = 8;
        patternCanvas.height = 8;
        const pCtx = patternCanvas.getContext('2d')!;
        pCtx.fillStyle = 'rgba(220, 53, 69, 0.12)';
        pCtx.fillRect(0, 0, 8, 8);
        pCtx.strokeStyle = 'rgba(220, 53, 69, 0.18)';
        pCtx.lineWidth = 0.7;
        pCtx.beginPath(); pCtx.moveTo(0, 8); pCtx.lineTo(8, 0); pCtx.stroke();
        pCtx.beginPath(); pCtx.moveTo(-2, 2); pCtx.lineTo(2, -2); pCtx.stroke();
        pCtx.beginPath(); pCtx.moveTo(6, 10); pCtx.lineTo(10, 6); pCtx.stroke();
        const hatchPattern = canvasRef.current!.getContext('2d')!.createPattern(patternCanvas, 'repeat') as any;

        chartRef.current = new ChartJS(canvasRef.current, {
            type: 'line',
            data: {
                labels,
                datasets: [
                    {
                        // Dataset 1: fill azul de 0 até min(p, nominal)
                        label: `Geração (${kwp} kWp)`,
                        data: delivered,
                        borderColor: 'transparent',
                        backgroundColor: 'rgba(33, 150, 243, 0.3)',
                        fill: 'origin',
                        tension: 0.4,
                        pointRadius: 0,
                    },
                    {
                        // Dataset 2: fill vermelho de dataset1 até a curva real
                        // borderColor azul → traça a curva completa por cima
                        label: `Corte: ${clippingPct}% da energia`,
                        data: theoretical,
                        borderColor: 'transparent',
                        borderWidth: 0,
                        backgroundColor: hatchPattern,
                        fill: '-1',
                        tension: 0.4,
                        pointRadius: 0,
                    },
                    {
                        // Linha nominal tracejada
                        label: `${inversor} kW (nominal)`,
                        data: nominalLine,
                        borderColor: '#2196F3',
                        borderWidth: 1,
                        borderDash: [6, 4],
                        backgroundColor: 'transparent',
                        fill: false as any,
                        pointRadius: 0,
                        tension: 0,
                    },
                    ...(overloadLine ? [{
                        label: `${overloadMax.toFixed(1)} kW (overload max)`,
                        data: overloadLine,
                        borderColor: '#aaa',
                        borderWidth: 1,
                        borderDash: [6, 4],
                        backgroundColor: 'transparent',
                        fill: false as any,
                        pointRadius: 0,
                        tension: 0,
                    }] : []),
                ],
            },
            options: {
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    legend: {
                        position: 'top',
                        labels: {
                            filter: (item) => !item.text.includes('kW ('),
                            usePointStyle: true,
                        },
                    },
                    tooltip: {
                        mode: 'index' as const,
                        intersect: false,
                        filter: (item) => item.datasetIndex <= 1,
                        callbacks: {
                            title: (items) => items[0]?.label ? items[0].label : '',
                            label: (item) => `${item.dataset.label}: ${Number(item.raw).toFixed(2)} kW`,
                        },
                    },
                },
                scales: {
                    x: {
                        title: { display: true, text: 'Hora do dia' },
                        ticks: { maxRotation: 0 },
                        grid: { color: 'rgba(0,0,0,0.06)' },
                    },
                    y: {
                        title: { display: true, text: 'Potência (kW)' },
                        min: 0,
                        grid: { color: 'rgba(0,0,0,0.06)' },
                        ticks: { callback: (v) => `${Number(v).toFixed(1)}` },
                    },
                },
            },
        });

        return () => { chartRef.current?.destroy(); chartRef.current = null; };
    }, [kwp, inversor, overloadFator]);

    return (
        <div style={{ marginTop: 12 }}>
            <canvas ref={canvasRef} />
        </div>
    );
}

export function KitDetail(props: any) {
    const { kit, data, precoVenda, consumoMedio, descontoVendedor } = props;
    const { user } = useContext<any>(AuthContext);
    const [faturarPelaArgon, setFaturarPelaArgon] = useState(false);

    if(!kit.numeroPlacas){
        kit.referencia = kit.kit_referencia;
        kit.numeroPlacas = kit.kit_numero_placas;
        kit.inversor = kit.kit_inversor;
        kit.estrutura = kit.kit_estrutura;
        kit.link = kit.kit_link;
        kit.imagem = kit.kit_imagem;
        kit.potenciaPlacas = kit.kit_potencia_placas;
        kit.preco = kit.kit_preco;
        kit.kwp = kit.kit_kwp;
        kit.geracaoGarantida = kit.geracao_garantida;
        kit.dataHoraRastreado = kit.kit_data_hora_rastreado;
    }else{
        let incidenciaSolar = 3.36;
        if(data.incidenciaSolar && data.incidenciaSolar != ''){
            incidenciaSolar = data.incidenciaSolar;
        }
        kit.geracaoGarantida = kit.numeroPlacas * Math.round((kit.potenciaPlacas * incidenciaSolar * 30) / 1000)
    }

    if(!Array.isArray(kit.product_list)){
        kit.product_list = JSON.parse(kit.product_list);
    }

    const formatarData = (dataStr: string) => {
        if (!dataStr) return '-';
        const data = new Date(dataStr);
        return data.toLocaleDateString('pt-BR') + ' ' + data.toLocaleTimeString('pt-BR', { hour: '2-digit', minute: '2-digit' });
    };

    const custoDetalhadoProps = {
        ...props,
        faturarPelaArgon,
        setFaturarPelaArgon
    };

    return <>
        <div className="kit-detail kit-detail-3-cols">
            <div className="kit-detail-col kit-detail-left">
                <div className="kit-detail-header">
                    <a target="_blank" href={kit.link}><img src={kit.imagem} alt={kit.nome} /></a>
                    <table className="kit-info-table">
                        <tbody>
                            <tr>
                                <th>Referência</th>
                                <td>{kit.referencia}</td>
                            </tr>
                            <tr>
                                <th>Potência</th>
                                <td>{kit.kwp} kWp</td>
                            </tr>
                            <tr>
                                <th>Custo</th>
                                <td>{Util.moeda(kit.preco)}</td>
                            </tr>
                            <tr>
                                <th>Geração estimada</th>
                                <td>{kit.geracaoGarantida} kWh/mês - {(((kit.geracaoGarantida / consumoMedio))  * 100).toFixed(2)}% do consumo</td>
                            </tr>
                            <tr>
                                <th>Preço por kWh</th>
                                <td>{Util.moeda(precoVenda / kit.geracaoGarantida)}/kWh</td>
                            </tr>
                            <tr>
                                <th>Última atualização</th>
                                <td>{formatarData(kit.dataHoraRastreado)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <table className="kit-items-table">
                    <thead>
                        <tr>
                            <th>Qtd</th>
                            <th>Produto</th>
                        </tr>
                    </thead>
                    <tbody>
                        { kit.product_list.map((product: any, idx: number) => {
                            return <tr key={idx}>
                                <td style={{textAlign: 'center'}}>{product.qtd}</td>
                                <td>{product.nome}</td>
                            </tr>
                        }) }
                    </tbody>
                </table>
                <div style={{ padding: '8px 0' }}>
                    <OverloadBar kwp={kit.kwp} inversor={kit.inversor} overloadFator={kit.overloadFator ?? 1.3} />
                </div>
                <GeracaoChart kwp={kit.kwp} inversor={kit.inversor} overloadFator={kit.overloadFator ?? 1.3} />
            </div>
            <div className="kit-detail-col kit-detail-center">
                <MediaPrecos custoDetalhado={null} {...custoDetalhadoProps } />
            </div>
            <div className="kit-detail-col kit-detail-right">
                <CostDetail { ...custoDetalhadoProps } />
            </div>
        </div>
    </>;
}